const SPACE_REGEXP = /\s+/g;
const NONSLUG_REGEXP = /[^\w-]/g;

/** Matches a valid slug: lowercase alphanumeric, dashes, and underscores. */
export const SLUG_REGEXP = /^[a-z0-9_]+([_-][a-z0-9_]+)*$/;

export const HIDDEN_SLUG_PREFIX = "_";

/**
 * Sanitize text to a slug.
 * Like toKebab but preserves underscores.
 * Replaces spaces with dashes and removes non-word characters.
 * Lowercases the result.
 */
export const toSlug = (text: string): string | undefined => {
  const slug = text
    .trim()
    .replace(SPACE_REGEXP, "-")
    .replace(NONSLUG_REGEXP, "")
    .toLowerCase();

  if (slug === "-" || slug === "") return undefined;
  return slug;
};
